
import ClickOutside from 'vue-click-outside'

import ChevronIcon from '@/static/svg/chevron-icon.svg'
import EyeIcon from '@/static/svg/prescription/eye-icon.svg'

export default {
  components: {
    ChevronIcon,
    EyeIcon,
  },
  directives: {
    ClickOutside,
  },
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
    eyeId: {
      type: String,
      default: 'left',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedOption: {
      type: Object,
      default: () => ({ label: '' }),
    },
  },
  data() {
    return {
      isOpened: false,
      isLeftAligned: true,
      width: 0,
    }
  },
  computed: {
    hasOnlyOneOption() {
      return this.options.length === 1
    },
    isPower() {
      return this.type === 'power'
    },
    isColour() {
      return this.type === 'colour'
    },
    labels() {
      const labels = []
      const hasSomeNegativeOptions = this.options.some((option) => option.label.includes('-'))
      const hasSomePositiveOptions = this.options.some((option) => option.label.includes('+'))

      if (hasSomeNegativeOptions) labels.push(this.$t('product.prescription.minus'))
      if (hasSomePositiveOptions) labels.push(this.$t('product.prescription.plus'))

      return this.isPower ? labels : []
    },
    zeroPower() {
      return this.options.find((option) => option.label === '0.00')
    },
    rows() {
      const hasSomeNegativeOptions = this.options.some((option) => option.label.includes('-'))
      const hasSomePositiveOptions = this.options.some((option) => option.label.includes('+'))
      let rows = []

      if (this.isPower) {
        const unsignedValues = this.options.map((option) => option.label.replace(/\+|-/g, ''))
        const nonzeroValues = unsignedValues.filter((value) => value !== '0.00')
        const uniqueValues = nonzeroValues.filter((value, index, self) => self.indexOf(value) === index)

        uniqueValues.sort((valueA, valueB) => parseFloat(valueA) - parseFloat(valueB))

        uniqueValues.forEach((value) => {
          const row = []
          const negativeOption = this.options.find((option) => option.label === `-${value}`)
          const positiveOption = this.options.find((option) => option.label === `+${value}`)

          if (hasSomeNegativeOptions) row.push(negativeOption || { label: `-${value}` })
          if (hasSomePositiveOptions) row.push(positiveOption || { label: `+${value}` })

          rows.push(row)
        })
      } else {
        rows = this.options.map((option) => [option])
      }

      return rows
    },
  },
  mounted() {
    this.popupItem = this.$el
  },
  methods: {
    open(event) {
      const powerOptionMinWidth = 230
      const defaultMinWidth = 160
      const findClosest = (element, selector) => {
        for (; element && element !== document; element = element.parentNode) {
          if (element.matches(selector.toUpperCase())) return element
        }
        return null
      }

      const { view: page } = event
      const rootSection = findClosest(event.target, 'section')
      const { innerWidth: pageWidth } = page
      const { offsetLeft: parentLeftOffset, offsetWidth: parentWidth } = rootSection
      const freeSpaceRight = pageWidth - parentLeftOffset
      const minWidth = this.isPower && this.labels.length > 1 ? powerOptionMinWidth : defaultMinWidth

      this.width = Math.max(minWidth, parentWidth)
      this.isLeftAligned = freeSpaceRight > this.width
      this.isOpened = !this.disabled && !this.hasOnlyOneOption

      this.$nextTick(() => {
        if (this.$refs.optionsDrawer) {
          const padding = 10
          const globalHeaderHeight = document.querySelector('header')?.offsetHeight || 0
          const { height: optionsHeight, y: optionsY } = this.$refs.optionsDrawer.getBoundingClientRect()
          const scrollUpBy = optionsHeight - (window.innerHeight - optionsY)
          const scrollDownBy = optionsY - globalHeaderHeight

          if (scrollUpBy > 0) {
            window.scrollBy(0, scrollUpBy + padding)
          } else if (scrollDownBy < 0) {
            window.scrollBy(0, scrollDownBy - padding)
          }
        }

        if (this.selectedOption.scrollTop) {
          this.$refs.optionsContainer.scrollTop = this.selectedOption.scrollTop
        }
      })
    },
    close() {
      this.isOpened = false
    },
    onSelect(option) {
      if (option.value) {
        const { scrollTop = 0 } = this.$refs.optionsContainer
        this.$emit('option-selected', { name: this.name, type: this.type, ...option, scrollTop })
        this.isOpened = false
      }
    },
  },
}
